export default __webpack_public_path__ + "static/media/chevron-left-charcoal.e3765b45.svg";